import { render, staticRenderFns } from "./NodeAnnotationBtn.vue?vue&type=template&id=22f6951e&scoped=true"
import script from "./NodeAnnotationBtn.vue?vue&type=script&lang=js"
export * from "./NodeAnnotationBtn.vue?vue&type=script&lang=js"
import style0 from "./NodeAnnotationBtn.vue?vue&type=style&index=0&id=22f6951e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6951e",
  null
  
)

export default component.exports